"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Notification.css");

var _styles = {
  "container": "Notification__container___2wgyp",
  "time-sensitive": "Notification__time-sensitive___1gJrN",
  "action-required": "Notification__action-required___Jp9GX",
  "label": "Notification__label___2PoSk",
  "heads-up": "Notification__heads-up___2r-T5",
  "success": "Notification__success___1yk5N",
  "text": "Notification__text___SzUaI",
  "cta-button": "Notification__cta-button___1PgqQ"
};

const styles = _bind.default.bind(_styles);

const Notification = (0, _mobxReact.observer)(({
  className,
  cta,
  label,
  style,
  text,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('container', label), className);

  const renderLabel = label => {
    return _react.default.createElement(_.Text, {
      tag: 'span',
      size: 13,
      className: styles('label'),
      variant: 'medium-all-caps'
    }, label.replace(/-/g, ' '));
  };

  const renderCta = cta => {
    const variant = label === 'time-sensitive' ? 'outlined' : 'contained';

    switch (cta.type) {
      case 'button':
        return _react.default.createElement(_.Button, {
          onClick: () => cta.onClick && cta.onClick(),
          small: true,
          variant: variant,
          className: styles('cta-button'),
          label: cta.text
        });

      case 'link':
        return _react.default.createElement(_.Link, {
          onClick: () => cta.onClick && cta.onClick(),
          href: cta.href && cta.href,
          target: cta.external ? '_blank' : '_self',
          className: styles('cta-button'),
          underline: true,
          inheritColor: true
        }, cta.text);

      default:
        return null;
    }
  };

  return _react.default.createElement("div", {
    style: style,
    className: composed_classname,
    "data-testid": dataTestId,
    ...props
  }, renderLabel(label), _react.default.createElement(_.Text, {
    tag: 'span',
    variant: 'regular',
    className: styles('text')
  }, text), cta && renderCta(cta));
});
var _default = Notification;
exports.default = _default;